import React from 'react';
import t from 'prop-types';
import BotoneraAreaImagenVisor from './botonera-area-imagen-visor';
import PieBotoneraVisor from './pie-botonera-visor';

var BotoneraAreaImagenVisorIzquierda = function BotoneraAreaImagenVisorIzquierda(_ref) {
  var paso = _ref.paso,
      onBotonAnteriorClick = _ref.onBotonAnteriorClick,
      txtNumVineta = _ref.txtNumVineta,
      onPlay = _ref.onPlay,
      playing = _ref.playing,
      children = _ref.children;
  return React.createElement(BotoneraAreaImagenVisor, null, onPlay && React.createElement('div', {
    className: 'botonModoAutomatico' + (playing ? ' activa' : ''),
    onClick: onPlay
  }), txtNumVineta && React.createElement('div', {
    className: 'numeroImagenVisorImagenes'
  }, txtNumVineta), onBotonAnteriorClick !== "no" && React.createElement(PieBotoneraVisor, null, paso <= 1 && React.createElement('div', {
    className: 'previaImagenVisorImagenes desactivado'
  }), paso > 1 && React.createElement('div', {
    className: 'previaImagenVisorImagenes',
    onClick: onBotonAnteriorClick
  })), children);
};

BotoneraAreaImagenVisorIzquierda.propTypes = process.env.NODE_ENV !== "production" ? {
  paso: t.number,
  onBotonAnteriorClick: t.func,
  txtNumVineta: t.string,
  onPlay: t.func,
  playing: t.bool,
  children: t.any
} : {};
export default BotoneraAreaImagenVisorIzquierda;